import { render, staticRenderFns } from "./DescargoSegPage.vue?vue&type=template&id=b540e0be"
import script from "./DescargoSegPage.js?vue&type=script&lang=js&external"
export * from "./DescargoSegPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports